
import ErrorSerializer from '~/serializer/Error'

export default {
  inject: ['emitter'],
  async asyncData({ app, $pageError }) {
    try {
      const list = (await app.$api.sale.get())?.result?.list
      return {
        list,
      }
    }
    catch (e) {
      const error = ErrorSerializer(e)
      new $pageError({
        ...error,
        message: error.code === 404 ? 'Акции не найдены' : error.message,
      })
    }
  },
  data() {
    return {
      list: null,
    }
  },
  head: {
    title: 'Акции',
  },
}
